<template>
  <div>
    <b-row v-if="label" align-h="center">
      <label class="d-block">{{ label }}</label>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Min" :label-for="fromId" label-align="center">
          <b-form-input
            :id="fromId"
            class="full-width"
            v-model="localValue.from"
            type="number"
            :step="step"
            :max="max"
            :min="min"
            v-bind="$attrs"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Max" :label-for="toId" label-align="center">
          <b-form-input
            :id="toId"
            v-model="localValue.to"
            class="full-width"
            type="number"
            :step="step"
            :max="max"
            :min="min"
            v-bind="$attrs"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      from: {
        type: Number,
        default: 0
      },
      to: {
        type: Number,
        default: 0
      },
      default() {
        return {
          from: 0,
          to: 0
        };
      }
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    fieldName: {
      type: String,
      required: false,
      default: null
    },
    step: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: null
    },
    min: {
      type: Number,
      required: false,
      default: null
    }
  },
  watch: {
    localValue: {
      handler(newVal) {
        newVal = this.formatValue(newVal);
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      }
    },
    fromId() {
      return `${this.fieldName}-from`;
    },
    toId() {
      return `${this.fieldName}-to`;
    }
  },
  methods: {
    formatValue(val) {
      let to = parseFloat(val.to);
      val.to = isNaN(to) ? 0 : to;
      let from = parseFloat(val.from);
      val.from = isNaN(from) ? 0 : from;
      return val;
    }
  }
};
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
